import React from 'react';
import moment from 'moment';
import { Oval, Preloader } from '../../global/Preloader';

const NotificationItem = React.memo(({ notification, index, expandedNotificationIndex, handleExpandClick, t }) => (
  <div
    className={`notification-menu-item ${notification.isRead ? 'notification-read-unread' : ''} ${notification.category === 'Warning' ? 'notification-warning' : ''}`}
    key={notification.id || index}
  >
    <div className="notification-message">
      <div className='notification-list'>
        <div className='notification-msg-date'>
          <span>{notification.title ?? t("navbar.noMessage", "No message available")}</span>
          <span className='notification-date'>
            {moment(notification.timestamp).format("DD/MM/YYYY HH:mm")}
          </span>
        </div>
        <div
          className={`notification-description ${expandedNotificationIndex === index ? 'expanded' : ''}`}
          style={{ maxHeight: expandedNotificationIndex === index ? 'none' : '80px' }}
        >
          {notification.message ?? t("navbar.noDescription", "No description available")}
        </div>
        {notification.message?.length > 200 && (
          <span onClick={() => handleExpandClick(index)} className="expand-text">
            {expandedNotificationIndex === index ? t("navbar.showLess", "Show less") : t("navbar.showMore", "Show more...")}
          </span>
        )}
      </div>
    </div>
  </div>
));

const NotificationList = ({
  notifications,
  notificationCounts,
  params,
  loading,
  expandedNotificationIndex,
  parsedNotificationsArr,
  notificationListRef,
  notificationTypes,
  markRead,
  setMarkRead,
  handleParamsChange,
  handleExpandClick,
  getNotificationGroup,
  isFullPage,
  t
}) => {
  return (
    <div className={`notification-body ${isFullPage ? 'notification-body--fullpage' : ''}`}>
      <div className='header-section'>
        {parsedNotificationsArr.map((notificationType) => (
          <div
            className={`header-item ${notificationType.value === params.type && "active"}`}
            key={notificationType.value}
            onClick={() => {
              handleParamsChange("type", notificationType.value);
              if (notificationType.value !== notificationTypes.all.value) {
                setMarkRead(prev => ({
                  ...prev,
                  [notificationType.value]: true
                }));
              }
            }}
          >
            {notificationType.label}
            {!markRead[notificationType.value] && notificationCounts[notificationType.value] > 0 && (
              <span className="notification-dot">{notificationCounts[notificationType.value]}</span>
            )}
          </div>
        ))}
      </div>
      <div className="notification-menu-list" ref={notificationListRef}>
        {notifications?.length > 0 ? (
          notifications.reduce((acc, notification, index) => {
            const group = getNotificationGroup(notification.timestamp);
            if (index === 0 || getNotificationGroup(notifications[index - 1].timestamp) !== group) {
              acc.push(
                <h4 key={`header-${group}-${index}`} className="notification-group-header">
                  {t(`navbar.${group.toLowerCase()}`, group)}
                </h4>
              );
            }
            acc.push(
              <NotificationItem
                key={notification.id || index}
                notification={notification}
                index={index}
                expandedNotificationIndex={expandedNotificationIndex}
                handleExpandClick={handleExpandClick}
                t={t}
              />
            );
            return acc;
          }, [])
        ) : (
          !loading && (
            <div className='no-data-notification'>
              <img
                src="/notification.svg"
                alt={t("navbar.noNotificationsImageAlt", "No notifications")}
                style={{ width: "60px" }}
              />
              <h3>{t("navbar.noNotificationsFound", "No notifications found")}</h3>
            </div>
          )
        )}
        {loading && (
          <div className='d-flex justify-content-center align-items-center w-full' style={{ height: isFullPage ? 300 : 450 }}>
            <Preloader
              use={Oval}
              size={50}
              strokeWidth={9}
              strokeColor="#007567"
              duration={1000}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationList;
